import React from "react";

interface Props {
  className?: string;
}

export const GoogleLogo: React.FC<Props> = ({ className }) => (
  <svg
    aria-hidden="true"
    width="24"
    height="24"
    viewBox="0 0 24 24"
    className={className}
  >
    <path
      d="M19.9915 12.1496C19.9915 11.4941 19.9371 11.0158 19.8193 10.5197H12.1593V13.4784H16.6555C16.5649 14.2136 16.0754 15.3209 14.9876 16.065L14.9723 16.164L17.3943 17.9975L17.5621 18.0139C19.1031 16.6231 19.9915 14.5768 19.9915 12.1496Z"
      fill="#4285F4"
    />
    <path
      d="M12.1594 19.9451C14.3622 19.9451 16.2114 19.2364 17.5621 18.014L14.9877 16.0651C14.2987 16.5346 13.3741 16.8623 12.1594 16.8623C10.0019 16.8623 8.17081 15.4716 7.51807 13.5493L7.42239 13.5573L4.90403 15.4618L4.87109 15.5513C6.2127 18.1556 8.96848 19.9451 12.1594 19.9451Z"
      fill="#34A853"
    />
    <path
      d="M7.51805 13.5493C7.34582 13.0532 7.24614 12.5217 7.24614 11.9725C7.24614 11.4233 7.34582 10.8918 7.50899 10.3957L7.50443 10.2901L4.95451 8.35492L4.87108 8.3937C4.31813 9.47443 4.00085 10.688 4.00085 11.9725C4.00085 13.257 4.31813 14.4705 4.87108 15.5513L7.51805 13.5493Z"
      fill="#FBBC05"
    />
    <path
      d="M12.1594 7.08269C13.6914 7.08269 14.7248 7.72934 15.314 8.26974L17.6165 6.07286C16.2024 4.7884 14.3622 4 12.1594 4C8.96849 4 6.21271 5.78937 4.87109 8.39371L7.50901 10.3957C8.17082 8.47347 10.0019 7.08269 12.1594 7.08269Z"
      fill="#EB4335"
    />
  </svg>
);
